import type DbDataModel from '../../../models/DbDataModel';
import { requestAndParse, requestSuccessful } from '../request';

const getUserPayments = async (userId: number) => {
    const route = 'admin/get-user-payments';
    const payload = { userId };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const payments = response.body?.payments as DbDataModel[];
    const message = response.body?.message as string;

    return { success, payments, message };
};

export default getUserPayments;
